import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './Pages/HomePage';
import MedicalConsultations from './Pages/MedicalConsultations';
import MedicalArticles from './Pages/MedicalArticles';
import AdminDashboard from './Pages/AdminDashboard';
import ConsultationDetails from './Pages/ConsultationDetails';
import ArticleDetails from './Pages/ArticleDetails';
import Footer from './components/Footer';
import './App.css';
import AboutPage from './Pages/AboutPage';
import Auth from './components/Auth';
import { RequireAuth } from './components/RequireAuth';

function App() {
  return (
    <Router>
      <div className="App min-h-screen flex flex-col">
        <Navbar />
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/consultations" element={<MedicalConsultations />} />
            <Route path="/consultations/:id" element={<ConsultationDetails />} />
            <Route path="/articles" element={<MedicalArticles />} />
            <Route path="/articles/:id" element={<ArticleDetails />} />
            
            {/* لوحة التحكم - للمسؤولين فقط */}
            <Route 
              path="/dashboard" 
              element={
                <RequireAuth requireAdmin={true}>
                  <AdminDashboard />
                </RequireAuth>
              } 
            />
            
         
            
            {/* الصفحات العامة */}
            <Route path="/about" element={<AboutPage />} />
            <Route path="/auth" element={<Auth />} />
            
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;